// типы меток для карты
export enum MarkType {
  // метка которую ставим при клики по карте
  clickMark = 'clickMark',
  // метка для установки статичных объектов
  // например если нужно установить 1 метку и не двигать ее при клике
  staticMark = 'staticMark',
  // массив меток серверных центров
  // не рекомендую использовать для других целей
  // проще создать новый тип для нужных вам целей
  serviceMarks = 'serviceMarks',
  // метка для геолокации пользователя
  geolocationMark = 'geolocationMark',
}
